import { Member } from "../../../../types/employee.types";
import { CommonDetails, OpenEnrollmentWithPlan, StandardDetails } from "../../../../types/enrollment.types";
import { WaiveCoverageFormType } from "../../../../types/waiveDialogForm.types";
import { getCurrentDate } from "../../date";

export const generateICIWaiveEnrollmentPayload = (
	member: Member,
	openEnrollment: OpenEnrollmentWithPlan,
	waiveCoverageForm: WaiveCoverageFormType
): {
	standardDetails: StandardDetails[];
	commonDetails: CommonDetails;
} => {
	// console.log("waiveEnrollmentPayload======>>>", waiveCoverageForm);
	const standardDetails: StandardDetails[] = [
		{
			member_object_id: member._id,
			coverage_code: "EE",
			member_SSN: member.SSN,
			premium_amount: 0,
			is_tobacco: false
		}
	];
	const commonDetails: CommonDetails = {
		agent_id: null,
		location_number: member.location.location_number,
		location_name: member.location.location_name,
		group_number: member.group_number,
		group_name: member.group.name,
		plan_object_id: openEnrollment.plan._id,
		plan_code: openEnrollment.plan.plan_code,
		plan_name: openEnrollment.plan.plan_name,
		base_plan_name: openEnrollment.plan.plan_name,
		enrollment_status: "WAIVED",
		insured_object_id: member._id,
		insured_SSN: member.SSN,
		writing_number: 0,
		unenrolled_reason: null,
		waive_reason: waiveCoverageForm.waive_reason,
		other_waive_coverage: waiveCoverageForm.other_waive_coverage,
		waive_employee_cost: waiveCoverageForm.waive_employee_cost,
		termination_reason: null,
		enrollment_date: getCurrentDate(),
		effective_date: getCurrentDate(),
		termination_date: null,
		open_enrollment_id: openEnrollment._id
	};
	return {
		commonDetails,
		standardDetails
	};
};

export const generateICIGLTDPlanWaiveEnrollmentPayload = generateICIWaiveEnrollmentPayload;
